import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Menu } from '../../views/twig/components/Menu';
import { Header } from '../twig/components/Header';
import { ButtonToggle } from '../twig/components/ButtonToggle';
import { FrontPage } from '../twig/pages/front-page';
import { ArchivePublication } from '../twig/pages/archive-publication';
import { Single } from '../twig/pages/single';
import { ArchivePressReview } from '../twig/pages/archive-press_review';
//(new Analytics()).init();
//(new Carousel()).init();
//(new Collapse()).init();
//(new Demo()).init();
//(new Dropdown()).init();
(new LazyLoader()).init();
//(new ScrollSpy()).init();
(new Header()).init();
(new Menu()).init();
(new ButtonToggle()).init();
(new FrontPage()).init();
(new Single()).init();
(new ArchivePublication()).init();
(new ArchivePressReview()).init();
// Always at the end
//(new CookiesConsent()).init();
